import { render, staticRenderFns } from "./WagonLoadLimitGrid.vue?vue&type=template&id=0761bf59&scoped=true"
import script from "./WagonLoadLimitGrid.vue?vue&type=script&lang=js"
export * from "./WagonLoadLimitGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0761bf59",
  null
  
)

export default component.exports